import HeaderFa from "./Header-fa.json";
import HeaderEn from "./Header-en.json";
import HeaderAr from "./Header-ar.json";
import HeaderTr from "./Header-tr.json";

import FooterFa from "./Footer-fa.json";
import FooterEn from "./Footer-en.json";
import FooterAr from "./Footer-ar.json";
import FooterTr from "./Footer-tr.json";

import CircularFeatureOrbitFa from "./CircularFeatureOrbit-fa.json";
import CircularFeatureOrbitEn from "./CircularFeatureOrbit-en.json";
import CircularFeatureOrbitAr from "./CircularFeatureOrbit-ar.json";
import CircularFeatureOrbitTr from "./CircularFeatureOrbit-tr.json";

import TestimonialsFa from "./Testimonials-fa.json";
import TestimonialsEn from "./Testimonials-en.json";
import TestimonialsAr from "./Testimonials-ar.json";
import TestimonialsTr from "./Testimonials-tr.json";

import testimonialsCommon from "./testimonialsCommon.json";

export const componentLocales = {
    fa: {
        Header: HeaderFa,
        Footer: FooterFa,
        CircularFeatureOrbit: CircularFeatureOrbitFa,
        Testimonials: TestimonialsFa,
        testimonialsCommon: testimonialsCommon.fa,
    },
    en: {
        Header: HeaderEn,
        Footer: FooterEn,
        CircularFeatureOrbit: CircularFeatureOrbitEn,
        Testimonials: TestimonialsEn,
        testimonialsCommon: testimonialsCommon.en,
    },
    ar: {
        Header: HeaderAr,
        Footer: FooterAr,
        CircularFeatureOrbit: CircularFeatureOrbitAr,
        Testimonials: TestimonialsAr,
        testimonialsCommon: testimonialsCommon.ar,
    },
    tr: {
        Header: HeaderTr,
        Footer: FooterTr,
        CircularFeatureOrbit: CircularFeatureOrbitTr,
        Testimonials: TestimonialsTr,
        testimonialsCommon: testimonialsCommon.tr,
    },
};